import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import withFeatureFlags from 'hocs/withFeatureFlags';
import { connect } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import LabelSection from 'components/sections/LabelSection';
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper';
import { askDeleteModifier, onClickCancel } from 'actions/library/modifier';
import settingField from 'components/Fields/ReduxForm/SettingField/SettingField';
import { isDisableOutletLevelForm } from 'utils/userProperties';

import styles from './ModifierForm.css';
import ModifierOptions from './ModifierOptions';
import ModifierOptionsModal from './ModifierOptionsModal';

/**
 * This validation is commented out because PM wants to use the back-end validation
 * Reason : match moka-rails
 * https://mokapos.atlassian.net/browse/PS-527
 */
const validate = values => {
  const errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'This field is required';
  } else if (values.name.length > 100) {
    errors.name = 'Name max 100 char';
  }
  return errors;
};

const tooltipDeleteButton = (
  <Popover id="popover-trigger-hover-focus">
    This modifier cannot be deleted. Go to Business Library to delete
  </Popover>
);

const tooltipSaveButton = (
  <Popover id="popover-trigger-hover-focus">
    This modifier cannot be edited. Go to Business Library to modify
  </Popover>
);

class ModifierForm extends React.Component {
  render() {
    const {
      handleSubmit,
      modifier,
      outlets,
      isSubmittingForm,
      businessLibraryMenu,
      modifierDetail,
    } = this.props;

    const isDisableForm = isDisableOutletLevelForm(
      businessLibraryMenu,
      modifierDetail
    );

    return (
      <form className={styles.wrapper}>
        <div
          className={`${styles['content-wrapper']} modifier-content-wrapper`}
        >
          <div className="row mb-20px">
            <div className="col-sm-12">
              <Field component="input" type="hidden" name="id" />
              <LabelSection title="modifier set" />
              <div className="form-group">
                <Field
                  component={settingField}
                  name="name"
                  type="text"
                  placeholder="Name"
                  className="form-control"
                  dis={isDisableForm}
                />
              </div>
            </div>
          </div>
          <LabelSection title="modifier options" />
          <ModifierOptions disabled={isDisableForm} />
        </div>
        <ActionBarDetailWrapper>
          <span className="pull-left">
            {modifier.id &&
              (isDisableForm ? (
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="top"
                  overlay={tooltipDeleteButton}
                >
                  <button
                    className={`btn ${styles['disabled-button']}`}
                    onClick={e => e.preventDefault()}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </OverlayTrigger>
              ) : (
                <button
                  className="btn btn-danger"
                  onClick={this._onClickDelete}
                  disabled={isSubmittingForm}
                >
                  <i className="fa fa-trash" />{' '}
                </button>
              ))}
          </span>
          <span className="pull-right">
            <button
              className="btn btn-default mr-10px"
              onClick={this._onCancel}
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            {outlets.length > 1 && !modifier.id && (
              <button
                className="btn btn-primary mr-10px"
                onClick={handleSubmit(this._onSubmitCreateAllOutlet)}
                disabled={isSubmittingForm}
              >
                Save to All Outlet
              </button>
            )}
            {isDisableForm ? (
              <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="top"
                overlay={tooltipSaveButton}
              >
                <button
                  className={`btn ${styles['disabled-button']}`}
                  type="button"
                  onClick={e => e.preventDefault()}
                >
                  Save
                </button>
              </OverlayTrigger>
            ) : (
              <button
                className="btn btn-primary"
                onClick={handleSubmit(this._onSubmitSave)}
                disabled={isSubmittingForm}
              >
                Save
              </button>
            )}
          </span>
        </ActionBarDetailWrapper>
        <ModifierOptionsModal />
      </form>
    );
  }

  _onSubmitCreateAllOutlet = values => {
    this.props.onSubmit({ ...values, action: 'save_to_all_outlet' });
  };

  _onSubmitSave = values => {
    this.props.onSubmit({ ...values, action: 'save' });
  };

  _onClickDelete = event => {
    const { dispatch, modifierDetail } = this.props;
    dispatch(askDeleteModifier(modifierDetail));
    // prevent form from submitting
    event.preventDefault();
    event.stopPropagation();
  };

  _onCancel = e => {
    const { dispatch } = this.props;
    dispatch(onClickCancel());
    e.preventDefault();
    e.stopPropagation();
  };
}
const mapForm = {
  form: 'modifier',
  touchOnBlur: false,
  touchOnChange: false,
  validate,
  // TODO refactor
  // ni karena ada dua field yang sama ('options') di form dan modal,
  // kalo modalnya diclose, sama react bakal jadi 'unmounted'
  // dan kalo diunmount, redux form bakal destroy state reduxnya
  // akibatnya field yang ada di list options form bakal hilang validasinya
  // harusnya: dibikin dua field aja
  destroyOnUnmount: false,
};

const selector = formValueSelector('modifier');

function mapStateToProps(state) {
  const { modifierDetail, outlets, isSubmittingForm } = state.library.modifier;
  return {
    modifier: {
      id: selector(state, 'id'),
    },
    modifierDetail,
    outlets,
    isSubmittingForm,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapFlagsToProps = flags => ({
  businessLibraryMenu: flags.businessLibraryMenu,
});

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ModifierForm));

export default withFeatureFlags(mapFlagsToProps)(connected);
